import { domIsReady } from '@utilities/dom';
import { getParameterByName } from '@utilities/url';

const popups = new Map<string, Window>();

const openBindedPopup = (name: string, url: string) => {
  let popup = popups.get(name);
  if (popup && !popup.closed) {
    popup!.focus();
    return popup!;
  }

  popup = window.open(url, name, 'popup');
  window.addEventListener(
    'beforeunload',
    () => {
      popup.close();
    },
    { capture: true },
  );

  popups.set(name, popup);

  return popup;
};

export const openMatchSimulator = () => openBindedPopup('matchsimulator', '/test/matchsimulator/');

export const openJsonInject = () => openBindedPopup('jsoninject', '/test/jsoninject/');

// TESTING
if (getParameterByName('matchSimulator') === 'true') {
  domIsReady().then(() => {
    openMatchSimulator();
  });
}
if (getParameterByName('jsonInject') === 'true') {
  domIsReady().then(() => {
    openJsonInject();
  });
}
